import {Text, createStyles} from '@mantine/core';
import React, {useMemo} from 'react';

import InputChip from '../lib/InputChip';
import {parsePredictionInputs} from './predictionInputs';

/** Renders the parsed inputs from a prediction job's `configJson` as a row of chips. */
export function InputChips({configJson}: {configJson: Record<string, unknown>}): JSX.Element {
  const {classes} = useStyles();
  const inputs = useMemo(() => parsePredictionInputs(configJson), [configJson]);

  if (inputs.length === 0) {
    return (
      <Text color="dimmed" size="sm">
        —
      </Text>
    );
  }

  return (
    <div className={classes.inputChips}>
      {inputs.map((input, index) => (
        <InputChip
          key={`${input.type}-${index}`}
          label={input.name}
          tooltip={true}
          type={input.type}
          value={input.value}
        />
      ))}
    </div>
  );
}

const useStyles = createStyles(() => ({
  inputChips: {
    display: 'flex',
    flexWrap: 'wrap' as const,
    gap: 4,
  },
}));
